import { Link } from "react-router-dom";
import type { Video } from "@/types";

interface VideoCardProps {
  video: Video;
  index?: number;
}

export default function VideoCard({ video, index = 0 }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group block cursor-pointer animate-fadeUp"
      style={{ animationDelay: `${Math.min(index, 11) * 40}ms` }}
    >
      <div className="relative w-full aspect-video overflow-hidden rounded-lg bg-background-200 border border-background-200 group-hover:border-primary-300 transition-colors">
        <img
          src={video.cover}
          alt={`${video.title} 封面`}
          title={`${video.title} - 高清视频在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/70 via-transparent to-transparent opacity-80" />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-secondary-500 text-background-50 text-xs font-medium whitespace-nowrap">
          {video.type}
        </span>
        <span className="absolute top-2 right-2 px-1.5 py-0.5 rounded-md bg-primary-950/70 text-secondary-300 text-xs font-semibold whitespace-nowrap">
          {video.rating}
        </span>
        <span className="absolute bottom-2 left-2 px-2 py-0.5 rounded-md bg-background-50/90 text-primary-800 text-xs font-medium whitespace-nowrap">
          {video.episode}
        </span>
        <span className="absolute bottom-2 right-2 flex items-center justify-center w-7 h-7 rounded-full bg-background-50/90 text-primary-700 opacity-0 group-hover:opacity-100 transition-opacity">
          <i className="ri-play-fill text-sm" />
        </span>
      </div>
      <div className="pt-2.5">
        <h3 className="text-sm md:text-base font-medium text-foreground-950 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
          {video.title}
        </h3>
        <div className="mt-1.5 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
          <span>{video.region}</span>
          <span className="w-0.5 h-0.5 rounded-full bg-foreground-300" />
          <span>{video.year}</span>
          <span className="w-0.5 h-0.5 rounded-full bg-foreground-300" />
          <span>{video.updateDate.slice(5)} 更新</span>
        </div>
      </div>
    </Link>
  );
}